import React from "react";
import { cls } from "app/utils";
import styles from "./DateTime.module.scss";
import useCalendarPreferences from "app/utils/hooks/useCalendarPreferences";
import { timePattern } from "app/utils/timePattern";

const TimeSlot = ({
  time,
  isSelected,
  onSlotSelect,
  multiCoach = false,
  submitForm,
}) => {
  // CFTB-3431: the coach's clock on their public calendar, the reader's own in-app.
  const { preferences } = useCalendarPreferences();

  // CN-2652: grey pill, orange when chosen. The white-on-current-day variant
  // existed to pick one day out of a scrolling list; only one day is shown now.
  // Both greys are the page's own #f4f4f4 now, and the orange belongs to the
  // stylesheet with every other use of it rather than to this element.
  return (
    <div
      className={cls(styles.time_slot_container, {
        [styles.time_slot_selected]: isSelected,
      })}
      data-testid="time-slot"
      onClick={() => {
        onSlotSelect(time);
        // CN-2652: picking a time selects it; the confirm bar at the foot of the
        // screen is what books it. The multi-coach browse view has no such bar,
        // so there a tap still goes straight through.
        if (multiCoach) {
          setTimeout(() => submitForm(), 0);
        }
      }}
    >
      <div className={styles.time_slot_text}>
        {`${time.startHour.toFormat(timePattern(preferences.timeFormat))}`}
      </div>
    </div>
  );
};

export default TimeSlot;
